import React from 'react';

import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 141px;
  flex: 1;
`;
const Info = styled.div`
  color: var(--text-secondary);
  font-family: var(--font-bold);
  font-size: 18px;
  margin-bottom: 6px;
  text-align: center;
`;

const Note = styled.div`
  color: var(--text-secondary);
  font-size: 14px;
  text-align: center;
  margin-bottom: 20px;
`;

interface Props {
  info: string;
  note: string[];
}

const CompaniesCreateEditModalContentEmpty = ({ info, note }: Props) => (
  <Container>
    <Info>{info}</Info>
    <Note>
      {note.map((line, idx) => (
        <span key={idx}>
          {line}
          {idx < note.length - 1 && <br />}
        </span>
      ))}
    </Note>
  </Container>
);

export default CompaniesCreateEditModalContentEmpty;
